import { type RovoInstrumentedError } from '@atlassian/conversation-assistant-utils/httpUtils';

import { generateTraceId } from './generateTraceId';

export class NoActionInvokedError extends Error implements RovoInstrumentedError {
	errorAttributes: RovoInstrumentedError['errorAttributes'];

	constructor(
		message: string,
		params: {
			traceId: string | undefined;
		},
	) {
		super(message);
		this.name = this.constructor.name;
		if (typeof Error.captureStackTrace === 'function') {
			Error.captureStackTrace(this, this.constructor);
		}

		this.errorAttributes = {
			traceId: params.traceId ?? `NoActionInvoked-${generateTraceId()}`,
		};
	}
}
